import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-future-data',
  templateUrl: './future-data.component.html',
  styleUrls: ['./future-data.component.css']
})
export class FutureDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
